export enum ThemeEnv {
  DEV_THEME = 'DEV_THEME',
  DEMO_THEME = 'DEMO_THEME',
  SANDBOX_THEME = 'SANDBOX_THEME',
  PRODUCTION_THEME = 'PRODUCTION_THEME',
}
